webpackJsonp([1],{

/***/ "+0it":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  // const _this = this;
  // // 建议为了方便使用，这里可以包装window.Alert
  // window.Alert = function (msg, duration = 2000) {
  //   _this.$notify({
  //     title: 'error',
  //     message: msg,
  //     type: 'error',
  //     customClass: 'el-error-msg',
  //     duration
  //   });
  // }

  // window.Tips = function (msg, duration = 2000) {
  //   _this.$notify({
  //     title: 'success',
  //     message: msg,
  //     type: 'success',
  //     duration
  //   });
  // }

  // window.Warning = function (msg, duration = 2000) {
  //   _this.$notify({
  //     title: 'warning',
  //     message: msg,
  //     type: 'warning',
  //     duration
  //   });
  // }
};

exports.default = {
  init: init
};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("briU");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0xPk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1ein":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("wtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__interface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fecha__ = __webpack_require__("CdS8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fecha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fecha__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import locale from 'element-ui/lib/locale/lang/en'
//  import globalConfig from '../../config'  Shift Switch

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      totalLine: 0,
      loading: false,
      I18n: window.I18n,
      dialogChange: false,
      isBottom: false,
      isShow: true,
      formInline: {
        beginDate: '',
        endDate: '',
        branchId: [],
        userId: ''
      },
      queryObj: {
        beginDate: '',
        endDate: '',
        branchId: [],
        userId: '',
        currentPage: 1,
        pageSize: 30
      },
      userInfo: {
        startWorkDate: '',
        endWorkDate: '',
        agentName: '',
        totalInsured: '',
        totalPremium: ''
      },
      saleBarnchs: [],
      personOptions: [],
      tableData: []
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    // 获取用户信息
    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getuserInfo().then(function (data) {
      if (data.data.userType === 'EMPLOYEE') {
        _this.isShow = false;
      } else {
        _this.isShow = true;
      }
    });
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getchangeList({ pageSize: 30, currentPage: 1 }).then(function (data) {
      _this2.loading = false;
      _this2.totalLine = data.data.totalLine;
      if (data.data.data && data.data.data.length > 0) {
        data.data.data.forEach(function (item) {
          item.endWorkDate = _this2.getTime(item.endWorkDate);
        });
        _this2.tableData = data.data.data;
      } else {
        _this2.tableData = [];
      }
    });
    // 获取代理人列表
    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getagentNameList().then(function (data) {
      if (data.data && data.data.length > 0) {
        _this2.personOptions = data.data;
      } else {
        _this2.personOptions = [];
      }
    });
    // 获取机构列表
    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getbranchList().then(function (data) {
      _this2.saleBarnchs = data.data[0].childs;
      var getOptions = function getOptions(data, valueAlias, labelAlias) {
        var res = [];
        data.forEach(function (t, index) {
          res[index] = {
            value: t[valueAlias],
            label: t[labelAlias]
          };
          if (t.childs && t.childs.length) {
            res[index].children = getOptions(t.childs, valueAlias, labelAlias);
          }
        });
        return res;
      };
      _this2.saleBarnchs = getOptions(data.data, 'branchId', 'branchName');
    });

    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getchangeuserInfo().then(function (data) {
      if (data.data) {
        data.data.startWorkDate = _this2.getTime(data.data.startWorkDate);
        data.data.endWorkDate = _this2.getTime(data.data.endWorkDate);
        _this2.userInfo = data.data;
      }
    });
  },

  methods: {
    handleconfirm: function handleconfirm() {
      window.external.LoginOut();
      this.dialogChange = false;
    },
    changeOrder: function changeOrder() {
      this.dialogChange = true;
    },
    getTime: function getTime(value) {
      if (value && value !== 0) {
        var date = new Date(+value);
        return __WEBPACK_IMPORTED_MODULE_1_fecha___default.a.format(date, 'YYYY-MM-DD HH:mm');
      }
    },
    getDataList: function getDataList(val) {
      var _this3 = this;

      this.queryObj.currentPage = val;
      this.queryObj.userId = this.formInline.userId;
      this.isBottom = false;
      __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getchangeList(this.queryObj).then(function (data) {
        _this3.totalLine = data.data.totalLine;
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(function (item) {
            item.endWorkDate = _this3.getTime(item.endWorkDate);
          });
          _this3.tableData = data.data.data;
        } else {
          _this3.tableData = [];
        }
      });
    },
    getTableConcatList: function getTableConcatList() {
      var _this4 = this;

      this.queryObj.userId = this.formInline.userId;
      if (this.isBottom) return;
      __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getchangeList(this.queryObj).then(function (data) {
        // this.totalLine = data.data.totalLine
        _this4.loading = false;
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(function (item) {
            item.endWorkDate = _this4.getTime(item.endWorkDate);
          });
          // this.tableData = data.data.data.reverse().concat(this.tableData);
          _this4.tableData = _this4.tableData.concat(data.data.data);
        } else {
          _this4.isBottom = true;
        }
      });
    },
    getStartTime: function getStartTime(value) {
      if (value) {
        this.queryObj.beginDate = Date.parse(new Date(value));
      } else {
        this.queryObj.beginDate = '';
      }
    },
    getEndTime: function getEndTime(value) {
      if (value) {
        this.queryObj.endDate = Date.parse(new Date(value));
      } else {
        this.queryObj.endDate = '';
      }
    },
    handleChange: function handleChange() {},
    onSaleBarnchChange: function onSaleBarnchChange(arr) {
      var curObj = this.saleBarnchs;
      arr.forEach(function (t, index) {
        curObj = curObj.find(function (it) {
          return it.value === t;
        });
        if (curObj.children) curObj = curObj.children;
        // if (index === arr.length - 1 && curObj) resObj = curObj;
      });
      this.queryObj.branchId = curObj.value;
      this.getDataList();
    },
    onScroll: function onScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight) {
        if (this.isBottom) return;
        this.loading = true;
        this.queryObj.currentPage += 1;
        this.getTableConcatList();
      }
    }
  }
});

/***/ }),

/***/ "39or":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4vrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Handover"},[_c('div',{staticClass:"twolabs"},[_c('el-tabs',{staticStyle:{"height":"200px"},attrs:{"tab-position":"left","type":"card"}},[_c('el-tab-pane',{attrs:{"label":"Account Detail"}},[_c('div',{staticClass:"first-lab-right"},[_c('div',{staticClass:"user-breviary"},[_vm._v(_vm._s(_vm.userInfo.firstName))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"front-fontstyle",staticStyle:{"display":"inline-block"}},[_vm._v("Name ")]),_vm._v(_vm._s(_vm.userInfo.agentName))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"front-fontstyle",staticStyle:{"display":"inline-block"}},[_vm._v("Job No. ")]),_vm._v(_vm._s(_vm.userInfo.agentCode))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"front-fontstyle",staticStyle:{"display":"inline-block"}},[_vm._v("Account")]),_vm._v(_vm._s(_vm.userInfo.userName))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"front-fontstyle",staticStyle:{"display":"inline-block"}},[_vm._v("Branches")]),_vm._v(_vm._s(_vm.userInfo.branchName))])])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Change Password"}},[_c('div',{staticClass:"second-lab-right"},[_c('el-row',[_c('el-col',[_c('el-form',{staticClass:"demo-form-inline wordorder-form",attrs:{"inline":true,"model":_vm.formInline}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{staticClass:"pws",staticStyle:{"marginRight":"0"},attrs:{"label":"Previous Password","label-width":"200px"}},[_c('el-input',{attrs:{"type":"password","title":_vm.formInline.orderNo,"placeholder":"6-16 Letters Capitalize and Lowercase"},model:{value:(_vm.formInline.oldPassword),callback:function ($$v) {_vm.$set(_vm.formInline, "oldPassword", $$v)},expression:"formInline.oldPassword"}})],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{staticClass:"pws",staticStyle:{"marginRight":"0"},attrs:{"label":"Setup New Password","label-width":"200px"}},[_c('el-input',{attrs:{"type":"password","title":_vm.formInline.orderNo,"placeholder":"6-16 Letters Capitalize and Lowercase"},model:{value:(_vm.formInline.newPassword),callback:function ($$v) {_vm.$set(_vm.formInline, "newPassword", $$v)},expression:"formInline.newPassword"}})],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{staticClass:"pws",attrs:{"label":"Confirm Password","label-width":"200px"}},[_c('el-input',{attrs:{"type":"password","title":_vm.formInline.orderNo,"placeholder":"6-16 Letters Capitalize and Lowercase"},model:{value:(_vm.formInline.againNewPassword),callback:function ($$v) {_vm.$set(_vm.formInline, "againNewPassword", $$v)},expression:"formInline.againNewPassword"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticStyle:{"position":"absolute"},attrs:{"type":"primary"},on:{"click":_vm.getDataList}},[_vm._v("Confirm")])],1)],1)],1)],1)],1)])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9041":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9bN/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("rVsN");

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__("2sCs");

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__("QmSG");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ajax 模块，可以将 axios 替换成 $.ajax 等
 */
var GET_LANGUAGE_TYPE = '/get/i18n_type';
var GET_I18N = '/static/i18n/';
var GET_HEADER_LIST = '/headerList';
var PERMISSION_CHECK = '/permissionCheck';

var init = function init() {
  // alert(window.access)
  _axios2.default.interceptors.request.use(function (config) {
    if (config.url.indexOf(GET_LANGUAGE_TYPE) < 0 && config.url.indexOf(GET_HEADER_LIST) < 0 && config.url.indexOf(GET_I18N) < 0 && config.url.indexOf(PERMISSION_CHECK) < 0) {
      config.url = window.localStorage.gatewayDomain + config.url;
    }
    var cookies = _config2.default.getCookies();
    if (config.url.indexOf(GET_LANGUAGE_TYPE) < 0 && config.url.indexOf(GET_HEADER_LIST) < 0 && config.url.indexOf(GET_I18N) < 0) {
      config.url += 'access_token=' + cookies['access_token'];
      // config.url += ('access_token=' + window.access)
      // config.url += ('access_token=0769175f-3408-4e38-bc28-0b6802241111')
      // config.url += ('access_token=56766986-b522-4de7-b2c5-516f460b61ca')
    }
    if (!config.data) config.data = {};
    return config;
  }, function (err) {
    // return Promise.reject(err)
    return err;
  });
  // Add a response interceptor
  _axios2.default.interceptors.response.use(function (response) {
    var status = response.status,
        data = response.data;

    if (status === 200) {
      // 如果不出现错误，直接向回调函数内输出 data
      if (data.code === 'success') {
        return data;
      } else {
        return data;
      }
    } else {
      return response;
    }
  }, function (error) {
    var response = error.response;

    // 这里处理错误的 http code

    if (response.status === 404) {
      console.log('404 error %o' + error);
    }

    // Do something with response error
    return _promise2.default.reject(error);
  });
};

exports.default = {
  init: init
};

/***/ }),

/***/ "9qld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PerformanceQuery"},[_c('div',{staticClass:"queryContent"},[_c('el-row',[_c('el-col',[_c('el-form',{staticClass:"demo-form-inline wordorder-form",attrs:{"inline":true,"model":_vm.formInline}},[_c('el-form-item',{staticStyle:{"marginRight":"0"},attrs:{"label":"From ：","label-width":"120px"}},[_c('el-col',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","placeholder":"Please select time"},on:{"change":function($event){return _vm.getStartTime($event)}},model:{value:(_vm.formInline.beginDate),callback:function ($$v) {_vm.$set(_vm.formInline, "beginDate", $$v)},expression:"formInline.beginDate"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"marginRight":"0"},attrs:{"label":"To ：","label-width":"120px"}},[_c('el-col',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","placeholder":"Please select time"},on:{"change":function($event){return _vm.getEndTime($event)}},model:{value:(_vm.formInline.endDate),callback:function ($$v) {_vm.$set(_vm.formInline, "endDate", $$v)},expression:"formInline.endDate"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Insurance Branch：","label-width":"150px"}},[_c('el-cascader',{attrs:{"options":_vm.saleBarnchs,"placeholder":"Please select insurance branch","clearable":""},on:{"change":_vm.onSaleBarnchChange},model:{value:(_vm.formInline.branchId),callback:function ($$v) {_vm.$set(_vm.formInline, "branchId", $$v)},expression:"formInline.branchId"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"querybtn",staticStyle:{"position":"absolute"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.getDataList(1)}}},[_vm._v("Search")])],1),_vm._v(" "),_c('el-col',{staticClass:"lastform"},[_c('el-form-item',{attrs:{"label":"Operator：","label-width":"120px"}},[_c('el-select',{attrs:{"placeholder":"Please select operator","clearable":""},on:{"change":function($event){return _vm.getDataList(1)}},model:{value:(_vm.formInline.agentId),callback:function ($$v) {_vm.$set(_vm.formInline, "agentId", $$v)},expression:"formInline.agentId"}},_vm._l((_vm.personOptions),function(item){return _c('el-option',{key:item.agentId,attrs:{"label":item.agentName,"value":item.agentId}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Passport No.：","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"Search by Passport Number"},model:{value:(_vm.formInline.idNo),callback:function ($$v) {_vm.$set(_vm.formInline, "idNo", $$v)},expression:"formInline.idNo"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"totalrecord"},[_vm._v("Result of\n    "),_c('span',{staticClass:"lineheightfont"},[_vm._v(_vm._s(_vm.totalLine)+" ")])]),_vm._v(" "),_c('div',{ref:"tableWrap",staticStyle:{"height":"618px","overflow":"auto"},on:{"scroll":function($event){return _vm.onScroll($event)}}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"perform-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"approveDate","label":"Insurance time"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"branchName","label":"Insurance Branch"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idNo","label":"Passport No."}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"policyStatus","label":"Policy Status"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periodTotalPremium","label":"Payment from Customer"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"agentName","label":"Operator"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"agentCode","label":"Operator ID "}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BDeZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cmfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FMa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("KOpT");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_33843140_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4vrd");
function injectStyle (ssrContext) {
  __webpack_require__("x5JQ")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33843140"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_33843140_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KOpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("wtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__interface__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//  import globalConfig from '../../config'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      I18n: window.I18n,
      userInfo: {
        agentName: '',
        agentCode: '',
        userName: '',
        branchName: '',
        firstName: ''
      },
      formInline: {
        startTime: '',
        endTime: '',
        organization: [],
        oldPassword: '',
        newPassword: '',
        againNewPassword: '',
        passportNo: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getuserInfo().then(function (data) {
      console.log(data.data);
      _this.userInfo = data.data;
    });
  },

  methods: {
    // 修改密码
    getDataList: function getDataList() {
      var _this2 = this;

      if (!this.userInfo.userName) {
        return window.Warning('user name does not exist');
      } else if (!this.formInline.newPassword || !this.formInline.againNewPassword) {
        return window.Warning('new password can not be empty');
      } else if (!this.formInline.oldPassword) {
        return window.Warning('old ciphers cant be empty');
      } else if (this.formInline.newPassword && this.formInline.againNewPassword) {
        if (this.formInline.newPassword !== this.formInline.againNewPassword) {
          return window.Warning('two inconsistencies in cipher input');
        }
        var passwordReg = /^\w{6,16}$/;
        var isLegal = passwordReg.test(this.formInline.newPassword);
        if (!isLegal) {
          return window.Warning('new password is invaild');
        }
      }
      var parms = this.getParam();
      __WEBPACK_IMPORTED_MODULE_0__interface___default.a.changePassword(parms).then(function (data) {
        if (data.data.error === 'SUCCESS') {
          _this2.$notify({
            title: 'Success',
            message: data.data.message,
            type: 'success'
          });
          _this2.formInline.oldPassword = '';
          _this2.formInline.newPassword = '';
          _this2.formInline.againNewPassword = '';
        } else {
          _this2.$notify({
            title: 'Error',
            message: data.data.message,
            type: 'error'
          });
        }
      });
    },

    // 组装参数
    getParam: function getParam() {
      return {
        username: this.userInfo.userName,
        oldPassword: this.formInline.oldPassword,
        newPassword: this.formInline.newPassword
      };
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5ad6d633_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("39or");
function injectStyle (ssrContext) {
  __webpack_require__("9041")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5ad6d633_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("yf3K");

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__("briU");

var _elementUi = __webpack_require__("zUjc");

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__("BDeZ");

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _ajax = __webpack_require__("9bN/");

var _ajax2 = _interopRequireDefault(_ajax);

var _request = __webpack_require__("fiA/");

var _request2 = _interopRequireDefault(_request);

var _interface = __webpack_require__("wtao");

var _interface2 = _interopRequireDefault(_interface);

var _config = __webpack_require__("QmSG");

var _config2 = _interopRequireDefault(_config);

__webpack_require__("0xPk");

__webpack_require__("sywW");

var _es6Promise = __webpack_require__("r6k1");

var _es6Promise2 = _interopRequireDefault(_es6Promise);

var _en = __webpack_require__("R9Oo");

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_es6Promise2.default.polyfill();
// mock 启动
// if (/localhost/.test(location.href)) {

// 此处后续替换为修改过样式
__webpack_require__("qs/E");
// }

// 设置请求头
_request2.default.init();

// 插件配置
// Vue.use(ElementUI)
_vue2.default.use(_elementUi2.default, { locale: _en2.default });
_vue2.default.config.productionTip = false;

// 全局变量
window.localStorage.permissionCheckUrl = 'platform/v1/access/resources';
window.localStorage.defaultLanguage = 'EN_US';

// 动态设置环境
console.log("production");
if (false) {
  // dev环境
  window.localStorage.gatewayDomain = 'https://dev-api.zjlh.lan/';
  window.localStorage.serviceName = 'https://dev-hg-apply-thirdparty.zjlh.lan';
} else if (false) {
  // stag预发布环境
  window.localStorage.gatewayDomain = 'https://stag-api.gc-life.cn/';
  window.localStorage.serviceName = 'https://stag-hg-apply-thirdparty.gc-life.cn';
} else if (true) {
  // 生产环境
  window.localStorage.gatewayDomain = 'https://api.gc-life.com/';
  window.localStorage.serviceName = 'https://bmp-hg-apply-thirdparty.gc-life.com';
}
console.log(window.localStorage.gatewayDomain);

// axios 统一配置
_ajax2.default.init();

_config2.default.init();

// 此处调用国际化接口，获取国际化数据
_interface2.default.getI18nType().then(function (data) {
  _interface2.default.getI18n(data.type).then(function () {
    /* eslint-disable no-new */
    new _vue2.default({
      el: '#app',
      router: _router2.default,
      template: '<App/>',
      components: { App: _App2.default }
    });
  });
});

/***/ }),

/***/ "QmSG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__("YaEn");

var _index2 = _interopRequireDefault(_index);

var _axios = __webpack_require__("2sCs");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// to do
var init = function init() {
  _index2.default.beforeEach(function (to, from, next) {
    if (to.matched && to.matched.length && to.matched[0].path) {
      checkPermission(to.matched[0].path).then(function (data) {
        if (data.data === 'true') {
          next();
        }
      });
    } else {
      if (to.path === '/') {
        next();
      } else {
        checkPermission(to.path).then(function (data) {
          if (data.data === 'true') {
            next();
          }
        });
      }
    }
    next();
  });
};

// Return the document's cookies as an object of name/value pairs.
function getCookies() {
  var cookies = {};
  var all = document.cookie;
  if (all === '') return cookies;
  var list = all.split('; ');
  for (var i = 0; i < list.length; i++) {
    var cookie = list[i];
    var p = cookie.indexOf('=');
    var name = cookie.substring(0, p);
    var value = cookie.substring(p + 1);
    value = decodeURIComponent(value);
    cookies[name] = value;
  }
  return cookies;
}

function getCookie(name) {
  var cookies = getCookies();
  var value = '';
  if (cookies && cookies[name]) {
    value = cookies[name];
  }
  return value;
}

// set cookie
function setCookie(name, value) {
  var cookie = name + '=' + encodeURIComponent(value);
  document.cookie = cookie;
}

function checkPermission(path) {
  return _axios2.default.get(window.localStorage.permissionCheckUrl + '?', {
    params: {
      requestUrl: path,
      httpMethod: 'GET',
      serviceName: window.localStorage.serviceName,
      type: 'FRONTEND_URL'
    }
  });
}

exports.default = {
  getCookies: getCookies,
  setCookie: setCookie,
  getCookie: getCookie,
  init: init
};

/***/ }),

/***/ "TltQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V1QB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("jnyD");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3f249d8d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("9qld");
function injectStyle (ssrContext) {
  __webpack_require__("zvN3")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f249d8d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3f249d8d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("yf3K");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("mB6C");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _PerformanceQuery = __webpack_require__("V1QB");

var _PerformanceQuery2 = _interopRequireDefault(_PerformanceQuery);

var _HandOver = __webpack_require__("x8IB");

var _HandOver2 = _interopRequireDefault(_HandOver);

var _ReportForm = __webpack_require__("zwd9");

var _ReportForm2 = _interopRequireDefault(_ReportForm);

var _Account = __webpack_require__("FMa6");

var _Account2 = _interopRequireDefault(_Account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/PerformanceQuery',
    name: 'PerformanceQuery',
    component: _PerformanceQuery2.default
  }, {
    path: '/HandOver',
    name: 'HandOver',
    component: _HandOver2.default
  }, {
    path: '/ReportForm',
    name: 'ReportForm',
    component: _ReportForm2.default
  }, {
    path: '/Account',
    name: 'Account',
    component: _Account2.default
  }, {
    path: '/',
    name: 'PerformanceQuery',
    component: _PerformanceQuery2.default
  }]
});

/***/ }),

/***/ "ZgT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("wtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__interface__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//  import globalConfig from '../../config'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      I18n: window.I18n,
      totalLine: 0,
      loading: false,
      formInline: {
        beginDate: '',
        endDate: '',
        branchId: [],
        grade: 'D'
      },
      queryObj: {
        beginDate: '',
        endDate: '',
        branchId: '',
        grade: '',
        currentPage: 1,
        pageSize: 30
      },
      saleBarnchs: [],
      personOptions: [],
      tableData: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getreportList({ currentPage: 1, pageSize: 30 }).then(function (data) {
      _this.loading = false;
      _this.totalLine = data.data.totalLine;
      // this.userInfo = data.data
      if (data.data.data && data.data.data.length > 0) {
        _this.tableData = data.data.data;
      } else {
        _this.tableData = [];
      }
    });
    // 获取机构列表
    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getbranchList().then(function (data) {
      _this.saleBarnchs = data.data[0].childs;
      var getOptions = function getOptions(data, valueAlias, labelAlias) {
        var res = [];
        data.forEach(function (t, index) {
          res[index] = {
            value: t[valueAlias],
            label: t[labelAlias]
          };
          if (t.childs && t.childs.length) {
            res[index].children = getOptions(t.childs, valueAlias, labelAlias);
          }
        });
        return res;
      };
      _this.saleBarnchs = getOptions(data.data, 'branchId', 'branchName');
    });
  },

  methods: {
    getDataList: function getDataList() {
      var _this2 = this;

      this.queryObj.currentPage = 1;
      this.queryObj.grade = this.formInline.grade;
      this.isBottom = false;
      __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getreportList(this.queryObj).then(function (data) {
        _this2.loading = false;
        _this2.totalLine = data.data.totalLine;
        // this.userInfo = data.data
        if (data.data.data && data.data.data.length > 0) {
          _this2.tableData = data.data.data;
        } else {
          _this2.tableData = [];
        }
      });
    },
    getTableConcatList: function getTableConcatList() {
      var _this3 = this;

      this.queryObj.grade = this.formInline.grade;
      if (this.isBottom) return;
      __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getreportList(this.queryObj).then(function (data) {
        _this3.loading = false;
        if (data.data.data && data.data.data.length > 0) {
          _this3.tableData = _this3.tableData.concat(data.data.data);
        } else {
          _this3.isBottom = true;
        }
      });
    },
    onScroll: function onScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight) {
        if (this.isBottom) return;
        this.loading = true;
        this.queryObj.currentPage += 1;
        this.getTableConcatList();
      }
    },
    getStartTime: function getStartTime(value) {
      if (value) {
        this.queryObj.beginDate = Date.parse(new Date(value));
      } else {
        this.queryObj.beginDate = '';
      }
    },
    getEndTime: function getEndTime(value) {
      if (value) {
        this.queryObj.endDate = Date.parse(new Date(value));
      } else {
        this.queryObj.endDate = '';
      }
    },
    handleChange: function handleChange() {},
    timeChange: function timeChange(value) {
      this.formInline.grade = value;
      this.getDataList();
    },
    onSaleBarnchChange: function onSaleBarnchChange(arr) {
      var curObj = this.saleBarnchs;
      arr.forEach(function (t, index) {
        curObj = curObj.find(function (it) {
          return it.value === t;
        });
        if (curObj.children) curObj = curObj.children;
        // if (index === arr.length - 1 && curObj) resObj = curObj;
      });
      this.queryObj.branchId = curObj.value;
      this.getDataList();
    }
  }
});

/***/ }),

/***/ "fiA/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("2sCs");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 设置公共请求头
var init = function init() {
  var url = window.location.search.toString();
  var arr = [];
  var isArr = {};
  arr = url.split('&');
  arr.forEach(function (l) {
    l = l.split('=');
    isArr[l[0]] = l[1];
  });
  _axios2.default.defaults.headers.common['deviceChannel'] = 'gclife_bmp_pc';
  _axios2.default.defaults.headers.common['language'] = window.localStorage.defaultLanguage;
  if (isArr.osType) {
    _axios2.default.defaults.headers.common['osType'] = isArr.osType;
  } else {
    _axios2.default.defaults.headers.common['osType'] = '';
  };
  if (isArr.deviceId) {
    _axios2.default.defaults.headers.common['deviceId'] = isArr.deviceId;
  } else {
    _axios2.default.defaults.headers.common['deviceId'] = '';
  };
  if (isArr.appVersion) {
    _axios2.default.defaults.headers.common['appVersion'] = isArr.appVersion;
  } else {
    _axios2.default.defaults.headers.common['appVersion'] = '';
  };
  if (isArr.district) {
    _axios2.default.defaults.headers.common['district'] = isArr.district;
  } else {
    _axios2.default.defaults.headers.common['district'] = '';
  };
  if (isArr.phoneModel) {
    _axios2.default.defaults.headers.common['phoneModel'] = isArr.phoneModel;
  } else {
    _axios2.default.defaults.headers.common['phoneModel'] = '';
  };
  if (isArr.osVersion) {
    _axios2.default.defaults.headers.common['osVersion'] = isArr.osVersion;
  } else {
    _axios2.default.defaults.headers.common['osVersion'] = '';
  };
  if (isArr.coordiate) {
    _axios2.default.defaults.headers.common['coordiate'] = isArr.coordiate;
  } else {
    _axios2.default.defaults.headers.common['coordiate'] = '';
  };
  if (isArr.networkType) {
    _axios2.default.defaults.headers.common['networkType'] = isArr.networkType;
  } else {
    _axios2.default.defaults.headers.common['networkType'] = '';
  };
  if (isArr.ipAddress) {
    _axios2.default.defaults.headers.common['ipAddress'] = isArr.ipAddress;
  } else {
    _axios2.default.defaults.headers.common['ipAddress'] = '';
  };
}; /**
    * Created by c0001 on 2018/6/15.
    */
exports.default = {
  init: init
};

/***/ }),

/***/ "jnyD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("wtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__interface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fecha__ = __webpack_require__("CdS8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fecha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fecha__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//  import globalConfig from '../../config'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      I18n: window.I18n,
      loading: false,
      totalLine: 0,
      isBottom: false,
      queryObj: {
        beginDate: '',
        endDate: '',
        branchId: [],
        agentId: '',
        idNo: '',
        currentPage: 1,
        pageSize: 30
      },
      formInline: {
        beginDate: '',
        endDate: '',
        branchId: [],
        agentId: '',
        idNo: ''
      },
      saleBarnchs: [],
      personOptions: [],
      tableData: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getfinanceList({ currentPage: 1, pageSize: 30 }).then(function (data) {
      _this.loading = false;
      _this.totalLine = data.data.totalLine;
      if (data.data.data && data.data.data.length > 0) {
        data.data.data.forEach(function (item) {
          item.approveDate = _this.getTime(item.approveDate);
        });
        _this.tableData = data.data.data;
      } else {
        _this.tableData = [];
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getagentNameList().then(function (data) {
      _this.isBottom = false;
      if (data.data && data.data.length > 0) {
        _this.personOptions = data.data;
      } else {
        _this.personOptions = [];
      }
    });
    // 获取机构列表
    __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getbranchList().then(function (data) {
      _this.saleBarnchs = data.data[0].childs;
      var getOptions = function getOptions(data, valueAlias, labelAlias) {
        var res = [];
        data.forEach(function (t, index) {
          res[index] = {
            value: t[valueAlias],
            label: t[labelAlias]
          };
          if (t.childs && t.childs.length) {
            res[index].children = getOptions(t.childs, valueAlias, labelAlias);
          }
        });
        return res;
      };
      _this.saleBarnchs = getOptions(data.data, 'branchId', 'branchName');
    });
  },

  methods: {
    getDataList: function getDataList(val) {
      var _this2 = this;

      this.isBottom = false;
      this.queryObj.currentPage = 1;
      this.queryObj.agentId = this.formInline.agentId;
      this.queryObj.idNo = this.formInline.idNo;
      __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getfinanceList(this.queryObj).then(function (data) {
        _this2.loading = false;
        _this2.totalLine = data.data.totalLine;
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(function (item) {
            item.approveDate = _this2.getTime(item.approveDate);
          });
          _this2.tableData = data.data.data;
        } else {
          _this2.tableData = [];
        }
      });
    },
    getTime: function getTime(value) {
      if (value && value !== 0) {
        var date = new Date(+value);
        return __WEBPACK_IMPORTED_MODULE_1_fecha___default.a.format(date, 'YYYY-MM-DD HH:mm');
      }
    },
    getTableConcatList: function getTableConcatList() {
      var _this3 = this;

      this.queryObj.agentId = this.formInline.agentId;
      this.queryObj.idNo = this.formInline.idNo;
      if (this.isBottom) return;
      __WEBPACK_IMPORTED_MODULE_0__interface___default.a.getfinanceList(this.queryObj).then(function (data) {
        _this3.loading = false;
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(function (item) {
            item.approveDate = _this3.getTime(item.approveDate);
          });
          _this3.tableData = _this3.tableData.concat(data.data.data);
        } else {
          _this3.isBottom = true;
        }
      });
    },
    onScroll: function onScroll(event) {
      if (this.isBottom) return;
      if (event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight) {
        this.loading = true;
        this.queryObj.currentPage += 1;
        this.getTableConcatList();
      }
    },
    getStartTime: function getStartTime(value) {
      if (value) {
        this.queryObj.beginDate = Date.parse(new Date(value));
      } else {
        this.queryObj.beginDate = '';
      }
    },
    getEndTime: function getEndTime(value) {
      if (value) {
        this.queryObj.endDate = Date.parse(new Date(value));
      } else {
        this.queryObj.endDate = '';
      }
    },
    handleChange: function handleChange() {},
    onSaleBarnchChange: function onSaleBarnchChange(arr) {
      // let resObj = {};
      var curObj = this.saleBarnchs;
      arr.forEach(function (t, index) {
        curObj = curObj.find(function (it) {
          return it.value === t;
        });
        if (curObj.children) curObj = curObj.children;
        // if (index === arr.length - 1 && curObj) resObj = curObj;
      });
      this.queryObj.branchId = curObj.value;
      this.getDataList();
    }
  }
});

/***/ }),

/***/ "pFfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PerformanceQuery"},[_c('div',{staticClass:"queryContent"},[_c('el-row',[_c('el-col',[_c('el-form',{staticClass:"demo-form-inline wordorder-form",attrs:{"inline":true,"model":_vm.formInline}},[_c('el-form-item',{staticStyle:{"marginRight":"0"},attrs:{"label":"From ："}},[_c('el-col',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","placeholder":"Please select time"},on:{"change":function($event){return _vm.getStartTime($event)}},model:{value:(_vm.formInline.beginDate),callback:function ($$v) {_vm.$set(_vm.formInline, "beginDate", $$v)},expression:"formInline.beginDate"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"marginRight":"0"},attrs:{"label":"To ："}},[_c('el-col',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","placeholder":"Please select time"},on:{"change":function($event){return _vm.getEndTime($event)}},model:{value:(_vm.formInline.endDate),callback:function ($$v) {_vm.$set(_vm.formInline, "endDate", $$v)},expression:"formInline.endDate"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Insurance Branch: "}},[_c('el-cascader',{attrs:{"options":_vm.saleBarnchs,"clearable":"","placeholder":"Please select insurance branch"},on:{"change":_vm.onSaleBarnchChange},model:{value:(_vm.formInline.branchId),callback:function ($$v) {_vm.$set(_vm.formInline, "branchId", $$v)},expression:"formInline.branchId"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"querybtn",staticStyle:{"position":"absolute"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.getDataList()}}},[_vm._v("Search")])],1),_vm._v(" "),_c('el-col',{staticClass:"lastform"},[_c('el-form-item',[_c('el-radio-group',{staticStyle:{"margin-bottom":"30px"},on:{"change":_vm.timeChange},model:{value:(_vm.formInline.grade),callback:function ($$v) {_vm.$set(_vm.formInline, "grade", $$v)},expression:"formInline.grade"}},[_c('el-radio-button',{attrs:{"label":"D"}},[_vm._v("Day")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"M"}},[_vm._v("Month")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Y"}},[_vm._v("Year")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"totalrecord"},[_vm._v("Result of\n      "),_c('span',{staticClass:"lineheightfont"},[_vm._v(" "+_vm._s(_vm.totalLine))])]),_vm._v(" "),_c('div',{ref:"tableWrap",staticStyle:{"height":"617px","overflow":"auto"},on:{"scroll":function($event){return _vm.onScroll($event)}}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"report-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"dateStr","label":"Time"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"branchName","label":"Insurance Branch"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalInsured","label":"Insurance Amount"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"revokeSum","label":"Cancel Amount"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalPremium","label":"Income Amount"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qs/E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _mockjs = __webpack_require__("v4dE");

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_mockjs2.default.mock(/\/get\/i18n_type/, function () {
  return {
    code: 'success',
    data: {
      type: 'zh'
    },
    msg: 'ok'
  };
});

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_error__ = __webpack_require__("+0it");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_error__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {},
  mounted: function mounted() {
    // 全局错误初始化
    __WEBPACK_IMPORTED_MODULE_0__services_error___default.a.init.call(this);
  }
});

/***/ }),

/***/ "sywW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t9eY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Handover"},[_c('div',{staticClass:"twolabs"},[_c('el-tabs',{staticStyle:{"height":"200px"},attrs:{"tab-position":"left","type":"card"}},[(_vm.isShow)?_c('el-tab-pane',{attrs:{"label":"Shift Switch"}},[_c('div',{staticClass:"first-lab-right"},[_c('p',[_c('span',{staticClass:"front-fontstyle",staticStyle:{"display":"inline-block"}},[_vm._v("Shift time： ")]),_vm._v(_vm._s(_vm.userInfo.startWorkDate)+" ~ "+_vm._s(_vm.userInfo.endWorkDate))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"front-fontstyle",staticStyle:{"display":"inline-block"}},[_vm._v("Operator： ")]),_vm._v(_vm._s(_vm.userInfo.agentName))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"front-fontstyle",staticStyle:{"display":"inline-block"}},[_vm._v("Operator ID ： ")]),_vm._v(_vm._s(_vm.userInfo.agentCode))])]),_vm._v(" "),_c('ul',{staticClass:"totalInfo"},[_c('li',[_c('p',[_vm._v("The Number of Applicant")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.userInfo.totalInsured))])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("Total Cash Income(USD)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.userInfo.totalPremium))])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("Qty refund people")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.userInfo.revokeSum))])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("Sum insured of refund")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.userInfo.revokeAmt))])])]),_vm._v(" "),_c('el-button',{staticClass:"changebtn",attrs:{"type":"primary"},on:{"click":_vm.changeOrder}},[_vm._v("Shift Switch")])],1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Record"}},[_c('div',{staticClass:"second-lab-right"},[_c('el-row',[_c('el-col',[_c('el-form',{staticClass:"demo-form-inline wordorder-form",attrs:{"inline":true,"model":_vm.formInline}},[_c('el-form-item',{staticStyle:{"marginRight":"0"},attrs:{"label":"Form ：","label-width":"110px"}},[_c('el-col',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","placeholder":"Select start time"},on:{"change":function($event){return _vm.getStartTime($event)}},model:{value:(_vm.formInline.startTime),callback:function ($$v) {_vm.$set(_vm.formInline, "startTime", $$v)},expression:"formInline.startTime"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"marginRight":"0"},attrs:{"label":"To ：","label-width":"110px"}},[_c('el-col',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","placeholder":"Select expiry time"},on:{"change":function($event){return _vm.getEndTime($event)}},model:{value:(_vm.formInline.endTime),callback:function ($$v) {_vm.$set(_vm.formInline, "endTime", $$v)},expression:"formInline.endTime"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Insurance Branch：","label-width":"150px"}},[_c('el-cascader',{attrs:{"options":_vm.saleBarnchs,"placeholder":"Select insurance branch","clearable":""},on:{"change":_vm.onSaleBarnchChange},model:{value:(_vm.formInline.organization),callback:function ($$v) {_vm.$set(_vm.formInline, "organization", $$v)},expression:"formInline.organization"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticStyle:{"position":"absolute"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.getDataList(1)}}},[_vm._v("Search")])],1),_vm._v(" "),_c('el-col',{staticClass:"lastform"},[_c('el-form-item',{attrs:{"label":"Operator：","label-width":"110px"}},[_c('el-select',{attrs:{"placeholder":"Select operator","clearable":""},on:{"change":function($event){return _vm.getDataList(1)}},model:{value:(_vm.formInline.userId),callback:function ($$v) {_vm.$set(_vm.formInline, "userId", $$v)},expression:"formInline.userId"}},_vm._l((_vm.personOptions),function(item){return _c('el-option',{key:item.userId,attrs:{"label":item.agentName,"value":item.userId}})}),1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"totalrecord"},[_vm._v("Result of\n          "),_c('span',{staticClass:"lineheightfont"},[_vm._v(_vm._s(_vm.totalLine)+" ")])]),_vm._v(" "),_c('div',{ref:"tableWrap",staticStyle:{"height":"618px","overflow":"auto"},on:{"scroll":function($event){return _vm.onScroll($event)}}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"handover-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"endWorkDate","label":"Shift Switch Time"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"agentName","label":"Operator"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"agentCode","label":"Operator ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"branchName","label":"Insurance Branch"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalInsured","label":"Total Insured"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalPremium","label":"Payment from Customer","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"revokeSum","label":"qty refund people"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"revokeAmt","label":"sum insured of refund"}})],1)],1)])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Shift Switch Confirm","visible":_vm.dialogChange,"custom-class":"problem-content","append-to-body":""},on:{"update:visible":function($event){_vm.dialogChange=$event}}},[_c('div',{staticClass:"content",staticStyle:{"margin-top":"-10px"}},[_c('p',{staticStyle:{"font-size":"16px","color":"#666","margin-bottom":"15px"}},[_vm._v("Are you sure about shift Switch?")]),_vm._v(" "),_c('div',{staticClass:"btnwrap"},[_c('el-button',{staticStyle:{"margin-top":"10px"},on:{"click":function($event){_vm.dialogChange=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"primary"},on:{"click":_vm.handleconfirm}},[_vm._v("Confirm")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wtao":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("2sCs");

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__("KjI9");

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ajax = {
  // 获取i18n种类
  GET_LANGUAGE_TYPE: '/get/i18n_type'
};

var API_PATH_PRE_FIX = '/api';

// 增加前缀
var INTERFACE = {};
for (var key in ajax) {
  INTERFACE[key] = API_PATH_PRE_FIX + ajax[key];
}

/**
 * 获取 i18n 的种类
 */
function getI18nType() {
  // 这里需要先调用后端保存的语言
  return _axios2.default.get(INTERFACE.GET_LANGUAGE_TYPE);
}

/**
 * 获取i18n 配置json
 *
 * @param language
 * @private
 */
function getI18n() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'zh';

  return _axios2.default.get('/static/i18n/' + language + '/index.json').then(function (data) {
    window.I18n = data;
  });
}

function getfinanceList(data) {
  var c = 'policy/v1/ciq/policys?';
  return _axios2.default.get(c, { params: data }).catch(function (error) {
    console.log(error);
  });
}

function getuserInfo() {
  var c = 'agent/v1/agent/current?';
  return _axios2.default.get(c).catch(function (error) {
    console.log(error);
  });
}
// 交班记录
function getchangeList(data) {
  var c = 'apply/v1/ciq/works?';
  return _axios2.default.get(c, { params: data }).catch(function (error) {
    console.log(error);
  });
}
// 交班信息
function getchangeuserInfo() {
  var c = 'apply/v1/ciq/work?';
  return _axios2.default.get(c).catch(function (error) {
    console.log(error);
  });
}

// 报表
function getreportList(data) {
  var c = 'policy/v1/ciq/policy/report?';
  return _axios2.default.get(c, { params: data }).catch(function (error) {
    console.log(error);
  });
}

// 代理人列表
function getagentNameList(data) {
  var c = 'agent/v1/user/agents?';
  return _axios2.default.get(c, { params: data }).catch(function (error) {
    console.log(error);
  });
}

// 机构树列表
function getbranchList(data) {
  var c = 'agent/v1/user/branch/trees?';
  return _axios2.default.get(c, { params: data }).catch(function (error) {
    console.log(error);
  });
}

function postchangeOrder(data) {
  var c = 'apply/v1/ciq/work?';
  return _axios2.default.post(c, { params: data }).catch(function (error) {
    console.log(error);
  });
}

// 修改密码
function changePassword(data) {
  var c = 'auth/user/password/change?';
  return _axios2.default.get(c, { params: data }).catch(function (error) {
    console.log(error);
  });
}
// 登陆
function login(username, password) {
  return _axios2.default.post('auth/oauth/token', _qs2.default.stringify({ username: username, password: password, grant_type: 'password', scope: 'read', client_id: 'client_test', client_secret: 'secret_test' }), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

exports.default = {
  getI18n: getI18n,
  getI18nType: getI18nType,
  getfinanceList: getfinanceList,
  getuserInfo: getuserInfo,
  getchangeList: getchangeList,
  getchangeuserInfo: getchangeuserInfo,
  getreportList: getreportList,
  getagentNameList: getagentNameList,
  getbranchList: getbranchList,
  postchangeOrder: postchangeOrder,
  changePassword: changePassword,
  login: login
};

/***/ }),

/***/ "x5JQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x8IB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1ein");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_487529f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("t9eY");
function injectStyle (ssrContext) {
  __webpack_require__("TltQ")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-487529f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_487529f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zvN3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zwd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZgT4");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b68ffc0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("pFfa");
function injectStyle (ssrContext) {
  __webpack_require__("Cmfs")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b68ffc0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b68ffc0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.8dab4594ac3d9db0d810.js